import { request } from "../../../../services/api.ts"
import type { BasePagination } from "../../../../types/api.ts"
import type {
  ManagedListKey,
  ManagedListOption,
  ManagedListOptionPatch
} from "./list-options.types.ts"

const BASE_URL = "/templates-management/list-options"

const PATHS = {
  list: `${BASE_URL}/`,
  create: `${BASE_URL}/`,
  detail: (id: string) => `${BASE_URL}/${id}/`
}

// One page, because an order is only meaningful across the whole list.
export const WHOLE_LIST = 200

export const getListOptions = (listKey: ManagedListKey) =>
  request.api.get<BasePagination<ManagedListOption>>(PATHS.list, {
    list_key: listKey,
    page_size: WHOLE_LIST
  })

/** How many values the company holds across every managed list. */
export const countListOptions = () =>
  request.api.get<BasePagination<ManagedListOption>>(PATHS.list, {
    page_size: 1
  })

export const createListOption = (listKey: ManagedListKey, label: string) =>
  request.api.post<ManagedListOption>(PATHS.create, {
    list_key: listKey,
    label
  })

export const updateListOption = (id: string, data: ManagedListOptionPatch) =>
  request.api.patch<ManagedListOption>(PATHS.detail(id), data)

export const deleteListOption = (id: string) =>
  request.api.delete(PATHS.detail(id))
